import React from 'react'
import Breadcrumbs from '../../common-elements/breadcrumbs/Breadcrumbs'
import { useTranslation } from 'react-i18next'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { LastLoginReportTable } from '../../data/users/LastActivityReport'
import { UserListTableData } from '../../data/users/UsersList'
import { tableHeaderStyles } from '../../styles/ReactSelectStyles'



function LastLoginReport() {
    const {t}=useTranslation()
  return (
    <div className="page-body">
         <Breadcrumbs mainTitle={t("LastLoginReport")} parent={t("Reports")} parentLink={`${process.env.PUBLIC_URL}/reports`}/>
         <Container fluid>
        <Row>
          <Col sm="12">
         

            <Card>
              <CardBody>
              <div className="list-product">
              <div className="table-responsive">
                <DataTable
                  data={UserListTableData}
                  columns={LastLoginReportTable(t)}
                  striped
                  pagination
                  subHeader
                //   subHeaderComponent={subHeaderComponentMemo}
                  pointerOnHover
                  customStyles={tableHeaderStyles}
                  highlightOnHover
                  noDataComponent={
                    <div className="text-center p-4 text-muted">
                      {t("NoActivityhistoryMessage")}
                    </div>
                  }
                />
                </div></div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default LastLoginReport
